// @ts-nocheck
import genRequest from "includes/request";
import { t } from "i18next";
import React from "react";
import { useQuery } from "react-query";
import PostContent from "../PostContent/PostContent";
import "./PostResponse.css";
function PostResponse({ postId, response }) {

	const { isLoading, data, error } = useQuery(
		["Posts", "ResponseOfPost", postId],
		() => genRequest("posts/" + postId + "/responses").catch(() => { }),
		{
			enabled: (postId && !response ? true : false),
			retry: 0,
		}
	);

	if (isLoading)
		return (
			<div className="post-content loading p-4">
				<div className="w-100" />
				<div className="w-50" />
				<div className="w-25" />
				<div className="w-35" />
			</div>
		);
	// posts/:id/responses answers a list: the complement is its first item
	let resp = response || (Array.isArray(data) ? data[0] : data);
	if (!resp || !resp?.txt?.length || error)
		return (false);
	return (<PostContent className="w-100 PostResponse" post={{ ...resp, title: t("Posts.POST_RESPONSE") }} />);
}

export default PostResponse;
